//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import lottie from 'lottie-web';
import * as api from '~/api/index';
import initTime from '~/plugins/initTime';
import { subStrNum } from '~/utils';
export default {
  name: 'InfiniteDtb',
  data() {
    return {
      isHidden: true,
      nowTime: '',
      finalDtbList: [],
      pureDtbList: [],
      liveId: null,
      newDtbList: [],
      isSeending: false,
      getTimeInterval: null,
      interval: null,
      purDtbList: [],
    };
  },
  async fetch() {
    const $axios = this.$nuxt.$axios;
    const data = await $axios(
      api.getDtbList({
        liveChannelId: 'all',
        limit: 20,
      })
    ).catch(() => ({}));
    this.purDtbList = data?.result ?? [];
  },
  mounted() {
    lottie.loadAnimation({
      container: document.getElementById('dtb-gif'),
      renderer: 'svg',
      loop: true,
      autoplay: true,
      path: '/svg-icon/dtb-img.json',
    });
    clearInterval(this.getTimeInterval);
    clearInterval(this.interval);
    this.isHidden = false;
    this.getTime();
    this.getTimeInterval = setInterval(() => {
      this.getTime();
    }, 1000);
    this.showDtb();
    this.interval = setInterval(() => {
      this.showDtb();
    }, 120000);

    const dtbBox = document.getElementById('infinite-overfolow-box');
    const dtbCt = document.getElementById('infinite-content');
    const that = this;
    const infiniteDtb = () => {
      const scrollTop = dtbBox.scrollTop || dtbBox.scrollTop;
      const clientHeight = dtbCt.offsetHeight;
      if (parseInt(scrollTop) + 495 > parseInt(clientHeight) - 100) {
        if (!that.isSeending) {
          that.isSeending = true;
          that.showDtb(that.liveId);
        }
      }
    };
    // infiniteDtb();
    dtbBox.addEventListener('scroll', infiniteDtb);
  },
  beforeDestroy() {
    clearInterval(this.getTimeInterval);
    clearInterval(this.interval);
    this.getTimeInterval = null;
    this.interval = null;
  },
  methods: {
    initTime(t) {
      return initTime(t);
    },
    subStr(item) {
      return subStrNum(item, 62);
    },
    getTime() {
      this.nowTime = initTime().format('Y-M-D H:m:s');
    },
    showDtb(t) {
      const liveId = t || '';
      let queryLimit = {
        liveChannelId: 'all',
        limit: 20,
      };
      if (t) {
        queryLimit = { liveChannelId: 'all', liveId, limit: 20 };
      }
      this.$axios(api.infidtbList(queryLimit)).then(res => {
        this.newDtbList = res?.result || [];
        if (!t && !this.pureDtbList?.[0]) {
          this.pureDtbList = res?.result ?? [];
          this.liveId = res.result[res.result.length - 1].id;
          this.processDtb();
        } else if (!t && this.pureDtbList?.[0]?.id < this.newDtbList?.[0]?.id) {
          this.newDtbList = this.newDtbList.reverse();
          for (let i = 0; i < this.newDtbList.length; i++) {
            if (this.pureDtbList?.[0].id < this.newDtbList?.[i]?.id) {
              this.pureDtbList.unshift(this.newDtbList[i]);
            }
          }
          this.processDtb();
        } else if (t) {
          this.pureDtbList.push(...res.result);
          this.liveId = res.result[res.result.length - 1].id;
          this.processDtb();
        }
      });
    },

    processDtb() {
      const pureDtbList = [...this.pureDtbList];

      pureDtbList.forEach((item, index) => {
        item.isnewDate = item.isnewDate || false;
        item.createTimeShow = initTime(item.createTime * 1000).format('H:m ');
        item.createTimeDate = initTime(item.createTime * 1000).format('Y-M-D');

        if (index < pureDtbList.length - 1) {
          if (
            initTime(item.createTime * 1000).format('MD') !==
            initTime(pureDtbList[+index + 1].createTime * 1000).format('MD')
          ) {
            pureDtbList[index + 1].isnewDate = true;
          }
        }
      });
      this.finalDtbList = [...pureDtbList];
      this.isSeending = false;
    },
  },
};
